module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/sophia-cataldo-5e6a88656b5fdc43efa8875727fa8756.jpg";